import { useState, useReducer, useEffect, Fragment } from 'react';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import FeaturedSellerAuctionDate from '@Components/Events/FeaturedSellerAuctionDate';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import listingsReducer from '@Components/Listings/ListingsReducer';
import ComplexBreadcrumb from '@Components/Shared/ComplexBreadcrumb';
const BiddingAgreementModal = loadable(() => import('@Components/Shared/Modals/BiddingAgreementModal'), true);
const EventListing = loadable(() => import('@Components/Events/EventListing'));

const UpcomingAuctionListView = (props) => {
    const currentSite = useRecoilValue(atoms.currentWebsite);
    const [listings, dispatchListings] = useReducer(listingsReducer, props?.ListPageAjaxModel?.Listings);

    const [biddingAgreementProps, setBiddingAgreementProps] = useState(null);
    const [showBiddingAgreementModal, setShowBiddingAgreementModal] = useState(false);

    const searchData = {
        ListingCountTitle: props?.ListPageAjaxModel?.ListingCountTitle,
        CurrentPage: props?.ListPageAjaxModel?.CurrentPage,
        TotalPages: props?.ListPageAjaxModel?.TotalPages,
        PageSize: props?.ListPageAjaxModel?.PageSize,
        ListingsCount: props?.ListPageAjaxModel?.ListingsCount,
    };

    const criteriaData = {
        MetaTitle: props?.FacetedSearchAjaxModel?.MetaTitle,
        PageHeader: props?.FacetedSearchAjaxModel?.PageHeader,
        SegmentBaseUrl: props?.FacetedSearchAjaxModel?.SegmentBaseUrl,
        BreadCrumbs: props?.FacetedSearchAjaxModel?.BreadCrumbs,
        SearchBaseURL: props.SearchBaseURL,

    };

    const openBiddingAgreementModal = (data) => {
        setBiddingAgreementProps(data);
        setShowBiddingAgreementModal(true);
    };

    const closeBiddingAggreementModal = () => {
        setBiddingAgreementProps(null);
        setShowBiddingAgreementModal(false);
    };

    return (
        <>
            {currentSite.IsFramelessSite ? (
                <div className='list-content' id='toplevellist'>
                    <section className="list-top-section">
                        <div className="list-bcrumbs-and-title">
                            <div className="ground-bcrumbs">
                                <ComplexBreadcrumb BreadCrumbModels={criteriaData?.BreadCrumbs} />
                            </div>
                            <div className="list-heading">
                                <h1 className="list-title">
                                    <span className="list-title-text">{criteriaData?.PageHeader}</span>
                                </h1>
                                {props?.UserCanViewListings && (
                                    <strong className="list-listings-count">
                                        &nbsp;{searchData?.ListingCountTitle}
                                    </strong>
                                )}
                            </div>
                        </div>
                    </section>
                    <section className='bottom-section'>
                        <div id='main-content' className='list-main-section no-search-bar'>
                            <div className="list-container list-container-flexrow" id="listContainer">
                                {listings.map((listing, index) => (
                                    <Fragment key={`${listing.Id}-${index}`}>
                                        <div className="list-listing-card-wrapper">
                                            <EventListing
                                                {...listing}
                                                IsWatchList={props.IsWatchList}
                                                setListings={dispatchListings}
                                                listings={listings}
                                                LocationString={searchData.LocationString}
                                                ShowAuctionBranding={props.ShowAuctionBranding}
                                                openBiddingAgreementModal={openBiddingAgreementModal}
                                            />
                                        </div>
                                    </Fragment>
                                ))}
                            </div>
                        </div>
                    </section>
                </div>
            ) : (
                <div className="main">
                    <div className="info-content-container">
                        <div className="at-upcoming-auctions-container">
                            <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
                                <h1 className="pagename border-bottom">{props.PageHeader}</h1>
                            {props.AuctionDates.map((vmDate, index) => (
                                ((vmDate.WeeklySale.FeaturedSellers && vmDate.WeeklySale.FeaturedSellers.length > 0) || vmDate.StandaloneSales?.length > 0) && (
                                    <FeaturedSellerAuctionDate
                                        {...vmDate}
                                    />
                                )
                            ))}
                        </div>
                    </div>
                </div >
            )}
            {
                (showBiddingAgreementModal && biddingAgreementProps) &&
                <BiddingAgreementModal
                    {...biddingAgreementProps}
                    onClose={closeBiddingAggreementModal}
                />
            }
        </>
    );
};

export default UpcomingAuctionListView;
